import { clearAttendanceStatus } from "./offline_queue"

const USER_KEY = "jukai_current_user_id"

document.addEventListener("DOMContentLoaded", async () => {
    const meta = document.querySelector('meta[name="current-user-id"]')
    if (!meta || !meta.content) return

    const currentUserId = meta.content
    const storedUserId = localStorage.getItem(USER_KEY)

    if (storedUserId && storedUserId !== currentUserId) {
        if ("serviceWorker" in navigator) {
            try {
                const reg = await navigator.serviceWorker.ready
                reg.active?.postMessage("clear-dynamic-cache")
            } catch {}
        }

        try {
            await clearAttendanceStatus()
        } catch {}

        localStorage.removeItem("selected_weather_id")
    }

    localStorage.setItem(USER_KEY, currentUserId)
})
